import React from "react";
import { Alert, Button, Result, Spin, Typography } from "antd";
import { fallbackReasonText } from "./livePreview";

const { Paragraph, Text } = Typography;

/**
 * The live-preview frame (DAB-861), or the card that replaces it when the
 * preview did not come up. Stateless: `useLivePreview` owns every decision.
 *
 * `sandbox`: scripts for the bridge, same-origin so the preview keeps its own
 * session cookie and scroll position — safe because the frame is on another
 * origin than admin. No forms, popups or top navigation: the preview only
 * shows pages. `no-referrer` keeps the admin URL out of the preview's logs.
 */
export default function LivePreviewPane({ state, frameRef, onRetry }) {
  if (state.status === "fallback") {
    return (
      <div className="mp-live__fallback">
        <Result
          status="info"
          title="Живият преглед не се зареди"
          subTitle={
            <>
              <Paragraph>{fallbackReasonText(state.reason)}</Paragraph>
              <Text type="secondary" data-testid="live-preview-reason">
                Код: {state.reason || "unknown"}
              </Text>
            </>
          }
          extra={[
            <Button key="retry" type="primary" onClick={onRetry} className="mp-live__action">
              Опитай отново
            </Button>,
          ]}
        />
      </div>
    );
  }

  const isLoading = state.status === "minting" || state.status === "loading";
  const isDegraded = state.status === "ready" && state.degraded.some((code) => code !== "untranslated");

  return (
    <div className="mp-live__frame-wrap">
      {isDegraded && (
        <Alert type="warning" showIcon banner message="Черновата не се зареди — показано е публикуваното съдържание" />
      )}
      {isLoading && (
        <div className="mp-live__loading">
          <Spin tip="Прегледът се зарежда…">
            <div className="mp-live__spin-area" />
          </Spin>
        </div>
      )}
      {state.url && (
        <iframe
          key={state.url}
          ref={frameRef}
          title="Жив преглед на черновата"
          className="mp-live__frame"
          src={state.url}
          sandbox="allow-scripts allow-same-origin"
          referrerPolicy="no-referrer"
        />
      )}
    </div>
  );
}
